import { PermissionsConjunction } from 'frontend-container/components/Menu/authorization/types';
import { MenuElement } from 'frontend-container/components/Menu/types';

import { ProfilesSettingCode, propertyPermissionKeys } from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { IconName } from '@ac/web-components';

export const commissionsMenu: MenuElement = {
  translation: 'MENU.COMMISSIONS.TITLE',
  icon: IconName.commission,
  id: 'menu-commissions',
  settings: [ProfilesSettingCode.TravelAgentCommissions],
  items: [
    {
      link: `${acConfig.newFrontendUrls.travelAgentCommissions}/dashboard`,
      aliases: [acConfig.newFrontendUrls.travelAgentCommissions],
      code: 'CommissionDashboard',
      translation: 'MENU.COMMISSIONS.ITEMS.DASHBOARD',
      permissionsConfiguration: {
        permissions: [propertyPermissionKeys.travelAgentCommissions.view],
        permissionsConjunction: PermissionsConjunction.Or,
      },
      keyboardShortcutWindows: 'alt+ctrl+z',
      keyboardShortcutMac: '⌥+⌘+z',
      keyCode: 90,
    },
  ],
};
